/* rb-pdp-extra-media-v11 — per-variant gallery sets (snippets/rb-pdp-extra-media.liquid).
   A variant with extra slides shows its own photo followed by its extras, with dots to move
   between them. Any other variant keeps the stock gallery and the extras stay hidden.
   Changing variant keeps the slide position: facts image to facts image, photo to photo, and the
   old slide dissolves into the new one. Moving between a photo and its facts image fades the facts
   image over the photo.
   Desktop: hovering the product photo shows its facts image and hovering a dot changes slide.
   Nothing zooms on desktop.
   Mobile: swipe or a tap on the product photo changes slide; a facts image pinch-zooms inside
   its own slide.
   Product photos never zoom.
   Thumbnails are built by the theme one per slide in the same order, so a slide's thumbnail
   is the nav item at the same index. */
(function () {
  var last = '';
  var timers = [];
  var settle = true;
  /* Slide a variant change lands on: the set position the shopper was viewing, so an open facts
     image stays open across variants and the photo stays the photo. */
  var want = 0;
  var restarted = 0;
  var desktopMq = window.matchMedia('(min-width: 1000px)');

  function gallery() {
    return document.querySelector('[data-main-media][data-rb-extra-media]');
  }

  function featuredMap(gal) {
    var el = gal.querySelector('[data-rb-extra-featured]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function selectedId() {
    var field = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (field && field.value) return String(field.value);
    return new URL(window.location.href).searchParams.get('variant') || '';
  }

  function flickity(gal) {
    var $ = window.jQuery_T4NT || window.jQuery;
    if (!$ || !gal.classList.contains('flickityt4s-enabled')) return null;
    return { $: $, api: $(gal).data('flickityt4s') };
  }

  function dots(gal, fl, count) {
    var bar = gal.parentNode.querySelector('.rb-pdp-extra-dots');
    /* rb-pdp-dots-hold-v1 — main-product.liquid holds the dot row's 28px until now */
    if (gal.hasAttribute('data-rb-dots-hold')) {
      gal.removeAttribute('data-rb-dots-hold');
      gal.style.removeProperty('margin-bottom');
    }
    gal.classList.toggle('rb-has-set', count >= 2);
    if (count < 2 || !fl || !fl.api) {
      if (bar) bar.remove();
      return;
    }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'rb-pdp-extra-dots';
      bar.setAttribute('role', 'tablist');
      gal.insertAdjacentElement('afterend', bar);
      var pick = function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        settle = false;
        move(gal, fl, Number(b.dataset.i));
      };
      bar.addEventListener('click', pick);
      bar.addEventListener('mouseover', function (e) { if (desktopMq.matches) pick(e); });
      fl.api.on('select', function () { paint(bar, current(fl.api)); });
    }
    swipe(gal, fl);
    crossfade(gal, fl);
    hoverSwap(gal, fl);
    pinchZoom(gal, fl);
    bar.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.i = i;
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + count);
      bar.appendChild(b);
    }
    paint(bar, current(fl.api));
  }

  /* Fade mode with groupCells 100% puts every cell in one slide, so the theme's own drag never
     changes slide. Swipe (touch, or mouse drag below desktop width) moves through the set. */
  function swipe(gal, fl) {
    if (gal.hasAttribute('data-rb-swipe')) return;
    gal.setAttribute('data-rb-swipe', '');
    var x0 = null, y0 = 0, swiped = false;
    function start(x, y) { x0 = x; y0 = y; swiped = false; }
    function end(x, y) {
      if (x0 === null) return;
      if (zoomLock) { x0 = null; return; }
      var dx = x - x0, dy = y - y0;
      x0 = null;
      if (!gal.parentNode.querySelector('.rb-pdp-extra-dots')) return;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      swiped = true;
      settle = false;
      var n = fl.api.cells.length;
      move(gal, fl, (current(fl.api) + (dx < 0 ? 1 : -1) + n) % n);
    }
    gal.addEventListener('touchstart', function (e) { start(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    gal.addEventListener('touchend', function (e) { end(e.changedTouches[0].clientX, e.changedTouches[0].clientY); }, { passive: true });
    gal.addEventListener('mousedown', function (e) { if (e.button === 0 && !desktopMq.matches) start(e.clientX, e.clientY); });
    window.addEventListener('mouseup', function (e) { end(e.clientX, e.clientY); });
    gal.addEventListener('click', function (e) {
      if (swiped) { swiped = false; e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* Within a set, the opaque facts image fades in over the photo or out over it while the photo stays
     solid for the length of the fade. The photo itself never fades: it is a transparent PNG and
     anything behind it would show through. A change of direction mid-fade reverses from where the
     fade is. */
  function crossfade(gal, fl) {
    if (gal.hasAttribute('data-rb-xfade')) return;
    gal.setAttribute('data-rb-xfade', '');
    var prev = fl.api.selectedElement;
    fl.api.on('select', function () {
      var cur = fl.api.selectedElement;
      if (cur === prev) return;
      var from = prev;
      prev = cur;
      mark(gal, from, cur);
    });
  }

  var fadeTimer = 0;
  function mark(gal, from, cur) {
    window.clearTimeout(fadeTimer);
    Array.prototype.forEach.call(gal.querySelectorAll('.rb-under,.rb-fadeout'), function (s) {
      s.classList.remove('rb-under', 'rb-fadeout');
    });
    if (!from || !cur || gal.classList.contains('rb-veil-on') || !gal.classList.contains('rb-has-set')) return;
    if (cur.classList.contains('rb-pdp-extra')) from.classList.add('rb-under');
    else if (from.classList.contains('rb-pdp-extra')) from.classList.add('rb-fadeout');
    fadeTimer = window.setTimeout(function () { from.classList.remove('rb-under', 'rb-fadeout'); }, 260);
  }

  /* Theme select handlers can restyle the gallery before ours runs, which would drop the outgoing
     facts image at once, so the fade is set up before the slide changes. */
  function move(gal, fl, i) {
    var from = fl.api.selectedElement, cell = fl.api.cells[i];
    if (cell && cell.element !== from) mark(gal, from, cell.element);
    try { fl.$(gal).flickityt4s('selectCell', i, false, false); } catch (e) {}
  }

  /* Desktop: pointing at the product photo brings up the facts image; leaving the gallery goes back
     to the photo, unless the pointer went to the dots. */
  function hoverSwap(gal, fl) {
    if (gal.hasAttribute('data-rb-hover')) return;
    gal.setAttribute('data-rb-hover', '');
    function go(i) {
      if (!desktopMq.matches || !gal.classList.contains('rb-has-set') || current(fl.api) === i) return;
      settle = false;
      move(gal, fl, i);
    }
    gal.addEventListener('mouseenter', function () { if (current(fl.api) === 0) go(1); });
    gal.addEventListener('mouseleave', function (e) {
      var to = e.relatedTarget;
      if (to && to.closest && to.closest('.rb-pdp-extra-dots')) return;
      go(0);
    });
  }

  function selectedImg(gal) {
    var slides = gal.querySelectorAll('[data-main-slide]:not(.is--media-hide)');
    var fl = flickity(gal);
    var i = fl && fl.api ? current(fl.api) : 0;
    var slide = slides[i] || slides[0];
    return slide ? slide.querySelector('.t4s-product__media > img[data-master]') : null;
  }

  /* Mobile: pinch a facts image to zoom it inside its own slide, drag to pan while zoomed, and
     double-tap to zoom in or back out. The slide's frame is the zoom window; nothing opens. Swipe
     only changes slide while the image is at its normal size. */
  var zoomLock = false;
  function pinchZoom(gal, fl) {
    if (gal.hasAttribute('data-rb-pinch')) return;
    gal.setAttribute('data-rb-pinch', '');
    var img = null, s = 1, tx = 0, ty = 0, pinch = null, pan = null, lastTap = 0, moved = false;

    function frame() { return img.parentNode; }
    function apply(animate) {
      img.style.transition = animate ? 'transform .25s ease' : 'none';
      img.style.transform = s > 1 ? 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')' : '';
    }
    function clamp() {
      var w = frame().clientWidth, h = frame().clientHeight;
      var mx = (w * s - w) / 2, my = (h * s - h) / 2;
      tx = Math.min(mx, Math.max(-mx, tx));
      ty = Math.min(my, Math.max(-my, ty));
    }
    function zoomAt(cx, cy, to) {
      var r = frame().getBoundingClientRect();
      var px = cx - r.left - r.width / 2, py = cy - r.top - r.height / 2;
      tx = px - (px - tx) * (to / s);
      ty = py - (py - ty) * (to / s);
      s = to;
      if (s <= 1.02) { s = 1; tx = 0; ty = 0; }
      clamp();
      zoomLock = s > 1;
      var master = img.getAttribute('data-master');
      if (s > 1 && master && img.getAttribute('src') !== master) img.setAttribute('src', master);
    }
    function reset() {
      if (img) { s = 1; tx = 0; ty = 0; apply(false); }
      img = null; pinch = null; pan = null; zoomLock = false;
    }
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }

    gal.addEventListener('touchstart', function (e) {
      if (desktopMq.matches) return;
      var target = e.target.closest && e.target.closest('.rb-pdp-extra .t4s-product__media');
      var next = target && target.querySelector('img[data-master]');
      if (!next) return;
      if (next !== img) { reset(); img = next; }
      moved = false;
      if (e.touches.length === 2) {
        pinch = { d: dist(e.touches), s: s };
        pan = null;
        zoomLock = true;
      } else if (e.touches.length === 1 && s > 1) {
        pan = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: tx, ty: ty };
      }
    }, { passive: true });

    gal.addEventListener('touchmove', function (e) {
      if (!img) return;
      if (pinch && e.touches.length === 2) {
        e.preventDefault();
        var t = e.touches;
        var cx = (t[0].clientX + t[1].clientX) / 2, cy = (t[0].clientY + t[1].clientY) / 2;
        if (pinch.cx != null) { tx += cx - pinch.cx; ty += cy - pinch.cy; }
        zoomAt(cx, cy, Math.min(4, Math.max(1, pinch.s * dist(t) / pinch.d)));
        pinch.s = s; pinch.d = dist(t); pinch.cx = cx; pinch.cy = cy;
        apply(false);
        moved = true;
      } else if (pan && e.touches.length === 1) {
        e.preventDefault();
        tx = pan.tx + e.touches[0].clientX - pan.x;
        ty = pan.ty + e.touches[0].clientY - pan.y;
        clamp();
        apply(false);
        if (Math.abs(e.touches[0].clientX - pan.x) + Math.abs(e.touches[0].clientY - pan.y) > 8) moved = true;
      }
    }, { passive: false });

    gal.addEventListener('touchend', function (e) {
      if (!img) return;
      if (pinch) {
        if (e.touches.length < 2) pinch = null;
        if (e.touches.length === 1 && s > 1) pan = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: tx, ty: ty };
        zoomLock = s > 1 || e.touches.length > 0;
        return;
      }
      pan = null;
      if (!e.touches.length) zoomLock = s > 1;
      if (moved || e.touches.length) return;
      var now = Date.now(), p = e.changedTouches[0];
      if (now - lastTap < 300) {
        zoomAt(p.clientX, p.clientY, s > 1 ? 1 : 2.5);
        apply(true);
        lastTap = 0;
      } else {
        lastTap = now;
      }
    }, { passive: true });

    /* Flickity drags on pointer events, which preventDefault on touchmove does not stop, so keep
       zoom and pan gestures from reaching it. */
    var fingers = {};
    function guard(e) {
      if (e.pointerType !== 'touch' || desktopMq.matches) return;
      if (e.type === 'pointerdown') fingers[e.pointerId] = 1;
      var many = Object.keys(fingers).length > 1;
      if (e.type === 'pointerup' || e.type === 'pointercancel') delete fingers[e.pointerId];
      if (e.type !== 'pointerup' && e.type !== 'pointercancel' && (s > 1 || many || zoomLock)) e.stopPropagation();
    }
    ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'].forEach(function (t) { gal.addEventListener(t, guard, true); });
    window.addEventListener('pointerup', function (e) { delete fingers[e.pointerId]; }, true);
    window.addEventListener('pointercancel', function (e) { delete fingers[e.pointerId]; }, true);

    /* The theme opens its own lightbox on a tap. A facts image zooms in place instead, and a tap on
       the product photo moves on to its facts image, as a swipe would. */
    gal.addEventListener('click', function (e) {
      if (desktopMq.matches) return;
      var media = e.target.closest('.t4s-product__media');
      if (!media) return;
      var extra = media.closest('.rb-pdp-extra');
      if (!extra && (e.defaultPrevented || !gal.classList.contains('rb-has-set'))) return;
      e.preventDefault();
      e.stopPropagation();
      if (extra) return;
      settle = false;
      var n = fl.api.cells.length;
      move(gal, fl, (current(fl.api) + 1) % n);
    }, true);

    /* Flickity re-selects the current cell on every resize; only a real slide change resets. */
    var shown = current(fl.api);
    fl.api.on('select', function () {
      var i = current(fl.api);
      if (i !== shown) { shown = i; reset(); }
    });
    desktopMq.addEventListener('change', reset);
  }

  function current(api) {
    var el = api.selectedElement;
    if (!el && api.selectedCell) el = api.selectedCell.element;
    for (var i = 0; i < api.cells.length; i++) if (api.cells[i].element === el) return i;
    return 0;
  }

  function paint(bar, index) {
    Array.prototype.forEach.call(bar.children, function (b, i) {
      b.classList.toggle('is-active', i === index);
      b.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
  }

  function sync() {
    var gal = gallery();
    if (!gal) return;
    var id = selectedId();
    var fl = flickity(gal);
    if (!id) return;
    if (id === last && fl) {
      /* The theme jumps to the variant's old slide index after a swatch change, later than the
         first sync, so keep the set on its first slide until the shopper moves it. */
      var at = target(fl.api);
      if (settle && gal.querySelector('[data-rb-extra-variant="' + id + '"]') && current(fl.api) !== at) {
        try { fl.$(gal).flickityt4s('selectCell', at, false, false); } catch (e) {}
      }
      return;
    }

    var featured = String(featuredMap(gal)[id] || '');
    var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-main-slide]'));
    var own = slides.filter(function (s) { return s.getAttribute('data-rb-extra-variant') === id; })
      .sort(function (a, b) {
        return Number(a.getAttribute('data-media-id').split('-').pop()) - Number(b.getAttribute('data-media-id').split('-').pop());
      });
    var hasSet = own.length > 0;
    if (hasSet) {
      /* The theme reorders slides on every variant change; put the set back as photo, extras. */
      var photo = slides.filter(function (s) {
        return !s.getAttribute('data-rb-extra-variant') && s.getAttribute('data-media-id') === featured;
      })[0];
      var parent = own[0].parentNode;
      (photo ? [photo] : []).concat(own).forEach(function (s) { parent.appendChild(s); });
      slides = Array.prototype.slice.call(gal.querySelectorAll('[data-main-slide]'));
    }
    var match = (gal.getAttribute('data-flickityt4s-js') || '').match(/"t4sid":\s*"([^"]+)"/);
    var nav = match ? document.querySelector('.carousel__nav--' + match[1]) : null;
    var navItems = nav ? nav.querySelectorAll('.t4s-carousel__nav-item') : [];

    var visible = 0;
    slides.forEach(function (slide, i) {
      var owner = slide.getAttribute('data-rb-extra-variant');
      var show = hasSet
        ? owner === id || (!owner && slide.getAttribute('data-media-id') === featured)
        : !owner;
      slide.classList.toggle('is--media-hide', !show);
      if (navItems[i]) navItems[i].classList.toggle('is--media-hide', !show);
      if (show) visible++;
    });

    if (!fl) return;
    last = id;
    /* The theme's thumbnail sync throws when its nav strip is hidden, as on this PDP; the
       carousel itself has already updated by then. */
    try { fl.$(gal).trigger('update.flickityt4s'); } catch (e) {}
    dots(gal, fl, hasSet ? visible : 0);
    if (hasSet) {
      try { fl.$(gal).flickityt4s('selectCell', target(fl.api), false, false); } catch (e) {}
    }
  }

  /* A variant change reshuffles the gallery for a few hundred ms (the old variant's facts image is
     selected on the way), so the slide on screen is held as a still copy over a hidden gallery until
     the new variant's slide has landed and loaded. Then that slide shows under the copy and the copy
     fades out. The copy has no background: the buy box glow reaches into the gallery, and the variant
     photos are transparent and line up, so the fade reads as the label changing. */
  var veil = null;

  function holdFrame() {
    var gal = gallery();
    if (!gal || (veil && !veil.released)) return;
    dropVeil();
    var img = selectedImg(gal);
    if (!img || !img.complete || !img.naturalWidth) return;
    var g = gal.getBoundingClientRect(), r = img.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var cs = getComputedStyle(img);
    var k = img.offsetWidth ? r.width / img.offsetWidth : 1;
    var el = document.createElement('img');
    el.className = 'rb-pdp-veil';
    el.alt = '';
    el.setAttribute('aria-hidden', 'true');
    el.src = img.currentSrc || img.src;
    el.style.cssText = 'left:' + (r.left - g.left) + 'px;top:' + (r.top - g.top) + 'px;width:' + r.width + 'px;height:' +
      r.height + 'px;object-fit:' + cs.objectFit + ';object-position:' + cs.objectPosition + ';border-radius:' +
      (parseFloat(cs.borderRadius) || 0) * k + 'px';
    gal.appendChild(el);
    gal.classList.add('rb-veil-on');
    veil = { el: el, gal: gal, t0: performance.now(), seen: null, since: 0, released: false };
    window.requestAnimationFrame(watchVeil);
  }

  function landed(gal, id, img) {
    var slide = img && img.closest('[data-main-slide]');
    if (!slide || slide.classList.contains('is--media-hide')) return false;
    var owner = slide.getAttribute('data-rb-extra-variant');
    if (owner) return owner === id;
    if (!gal.querySelector('[data-rb-extra-variant="' + id + '"]')) return true;
    return slide.getAttribute('data-media-id') === String(featuredMap(gal)[id] || '');
  }

  function watchVeil() {
    if (!veil || veil.released) return;
    var gal = veil.gal, now = performance.now(), id = selectedId();
    var img = selectedImg(gal);
    if (img !== veil.seen) { veil.seen = img; veil.since = now; }
    var hasSet = !!gal.querySelector('[data-rb-extra-variant="' + id + '"]');
    var ready = img && img.complete && img.naturalWidth > 0 && last === id && landed(gal, id, img) &&
      now - veil.since >= (hasSet ? 50 : 150);
    if ((ready && now - veil.t0 >= 120) || now - veil.t0 > 1500) {
      var v = veil;
      v.released = true;
      gal.classList.add('rb-veil-out');
      v.el.style.opacity = '0';
      window.setTimeout(function () { if (veil === v) dropVeil(); }, 260);
      return;
    }
    window.requestAnimationFrame(watchVeil);
  }

  function dropVeil() {
    if (!veil) return;
    if (veil.el.parentNode) veil.el.parentNode.removeChild(veil.el);
    veil.gal.classList.remove('rb-veil-on', 'rb-veil-out');
    veil = null;
  }

  function target(api) {
    return Math.max(0, Math.min(want, api.cells.length - 1));
  }

  (function style() {
    var css = '.rb-pdp-extra-dots{display:flex;justify-content:center;gap:10px;margin:14px 0 4px}' +
      '.rb-pdp-extra-dots button{width:10px;height:10px;padding:0;border:0;border-radius:999px;background:#c9d1da;cursor:pointer;transition:width .2s,background .2s}' +
      '.rb-pdp-extra-dots button.is-active{width:28px;background:#0e2744}' +
      '@media (max-width:999px){.rb-pdp-extra .t4s-product__media{overflow:hidden;touch-action:pan-y;border-radius:28px}.rb-pdp-extra .t4s-product__media>img{transform-origin:center center;will-change:transform}}' +
      '.rb-pdp-extra .t4s-product__media img{border-radius:28px}' +
      /* Product photos are transparent PNGs: a slide fading out behind one shows through it, so only
         the incoming slide fades and the outgoing one hides at once. */
      '[data-rb-extra-media].is-fade .flickityt4s-slider>[data-main-slide]:not(.is-selected){opacity:0!important;transition:none!important}' +
      '[data-main-media][data-rb-extra-media].rb-veil-on .flickityt4s-slider>[data-main-slide]{opacity:0!important;transition:none!important}' +
      '[data-main-media][data-rb-extra-media].rb-veil-on.rb-veil-out .flickityt4s-slider>[data-main-slide].is-selected{opacity:1!important}' +
      '[data-main-media][data-rb-extra-media].rb-has-set:not(.rb-veil-on) .flickityt4s-slider>[data-main-slide].is-selected:not(.rb-pdp-extra){transition:none!important}' +
      '[data-main-media][data-rb-extra-media].rb-has-set:not(.rb-veil-on) .flickityt4s-slider>.rb-pdp-extra.is-selected{z-index:3!important;transition:opacity .22s ease-in-out!important}' +
      '[data-main-media][data-rb-extra-media].rb-has-set:not(.rb-veil-on) .flickityt4s-slider>[data-main-slide].rb-under{opacity:1!important;z-index:1!important}' +
      '[data-main-media][data-rb-extra-media].rb-has-set:not(.rb-veil-on) .flickityt4s-slider>[data-main-slide].rb-fadeout{opacity:0!important;z-index:4!important;transition:opacity .22s ease-in-out!important}' +
      '.rb-pdp-veil{position:absolute!important;z-index:5;margin:0!important;padding:0!important;max-width:none!important;max-height:none!important;pointer-events:none;opacity:1;transition:opacity .22s ease-in-out}' +
      '@media (max-width:999px){.rb-has-set{cursor:grab}}' +
      '@media (min-width:1000px){' +
        '.rb-has-set .flickityt4s-viewport,.rb-has-set .flickityt4s-viewport *{cursor:default!important}' +
        '.rb-pdp-extra .t4s-product__media{overflow:hidden;border-radius:28px}' +
        '.rb-pdp-extra .t4s-product__media img{transform:scale(.95);transform-origin:left center}' +
        '.rb-pdp-extra-dots button{position:relative}' +
        '.rb-pdp-extra-dots button::before{content:"";position:absolute;inset:-12px -5px}' +
      '}';
    var el = document.createElement('style');
    el.textContent = css;
    document.head.appendChild(el);
  })();

  function schedule() {
    timers.forEach(function (t) { window.clearTimeout(t); });
    timers = [0, 150, 400, 900, 1800].map(function (ms) { return window.setTimeout(sync, ms); });
    timers.push(window.setTimeout(function () { settle = false; }, 1900));
  }

  function restart() {
    holdFrame();
    /* A swatch click and its change event both land here; only the first sees the old slide. */
    if (Date.now() - restarted > 1000) {
      var gal = gallery();
      var fl = gal && gal.classList.contains('rb-has-set') && flickity(gal);
      want = fl && fl.api ? current(fl.api) : 0;
    }
    restarted = Date.now();
    last = '';
    settle = true;
    schedule();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-value],[data-swatch-item],[data-swatch-option],.t4s-swatch__item')) restart();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) restart();
  }, true);
  document.addEventListener('pointerdown', function (e) {
    if (e.target && e.target.closest && e.target.closest('.rb-pdp-extra-dots,[data-main-media]')) settle = false;
  }, true);
  window.addEventListener('load', schedule);
  schedule();
})();
